import { FC } from "react";

function Careers() {
	return (
		<div className="text-primary flex flex-col items-center justify-center sm:mt-8">
			{/* Content container */}
			<div className="h-full flex flex-col overflow-clip sm:rounded-3xl sm:border sm:border-primary-inactive sm:max-w-[402px] mb-4">
				<UxTitle />
				<UxMascot />
				<UxContent />
			</div>
		</div>
	);
}

const UxTitle: FC = () => {
	return (
		<div
			className="relative pt-8 pb-16 bg-cover bg-center"
			style={{ backgroundImage: "url(./headerContour.png)" }}
		>
			<h1 className="text-4xl font-bold text-primary ml-4 mb-2">Careers</h1>
		</div>
	);
};

const UxMascot: FC = () => {
	return (
		<div className="relative -mt-12 px-6">
			<div className="w-24 h-24 mx-auto">
				<img
					src="../mappy-icon-BW.png"
					alt="Mappy mascot"
					className="w-full object-cover"
				/>
			</div>
		</div>
	);
};

const UxContent: FC = () => {
	return (
		<div className="mt-6 px-8 pb-6 space-y-4 text-primary">
			<p>
				Join us in transforming the job search experience for millions of
				people. We're building a team that's passionate about helping job
				seekers navigate their career journey with confidence.
			</p>
			<p>
				At JobMap, we believe in creating tools that make a real difference. Our
				team is dedicated, collaborative, and driven by a shared mission.
			</p>
			<p>
				We're always looking for talented individuals who share our values and
				want to contribute to something meaningful. If you're interested in
				joining our team, we'd love to hear from you. careers@jobmap.work
			</p>
			<p className="text-sm text-primary-inactive">
				Check back soon for open positions, or reach out to us directly to learn
				more about opportunities at JobMap.
			</p>
		</div>
	);
};

export default Careers;
